import type { PlatformName } from '@/types'

const names: Record<string, PlatformName> = {
    instagram: 'instagram',
    tiktok: 'tiktok',
    youtube: 'youtube',
    'youtube shorts': 'youtube',
    linkedin: 'linkedin',
    pinterest: 'pinterest',
    x: 'x',
    twitter: 'x'
}

/**
 * Maps a platform label stored in the CMS ("TikTok", "YouTube") to its icon.
 */
export const toPlatform = (label: string): PlatformName | null => names[label.trim().toLowerCase()] ?? null
